"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ts_validators_1 = require("ts-validators");
const General_1 = require("../types/General");
const objectSetValueByPath_1 = __importDefault(require("./objectSetValueByPath"));
const entryVarEvaluateEntries = async ({ entriesEntryVar, evaluateEntryVar, }) => {
    const entries = entriesEntryVar[General_1.DEFINITION_PROP_NAMES.ENTRIES];
    if (!entries) {
        return [];
    }
    const evaluatedEntries = await Promise.all(entries.map(async (entry) => Promise.all(entry
        .map((entryItem) => (entryItem ? evaluateEntryVar(entryItem) : undefined)))));
    let objectBuilded = {};
    evaluatedEntries.forEach((entry) => {
        const [valuePath, value] = entry;
        if (!(0, ts_validators_1.valueIsString)(valuePath)) {
            return;
        }
        objectBuilded = (0, objectSetValueByPath_1.default)(objectBuilded, valuePath.split('.'), value);
    });
    return objectBuilded;
};
exports.default = entryVarEvaluateEntries;
